export default __webpack_public_path__ + "static/media/39.38ea2de3.svg";